import './Operations.css';
import { IonIcon, IonItem, IonLabel, IonNote, IonText } from "@ionic/react";
import { syncOutline } from "ionicons/icons";
import moment from "moment";
import { Asset, DisplayableOperation } from "../../types/types";
import NumberFormat from "react-number-format";
import { useTranslation } from 'react-i18next';
import { RiExchangeFundsLine } from "react-icons/ri";
import { IconContext } from 'react-icons';

interface TradingProps {
    operation: DisplayableOperation;
    onClick: Function;
    asset: Asset[];
    filterAsset?: Asset;
}

const TradingListItem: React.FC<TradingProps> = ({ operation, asset, onClick, filterAsset }) => {

    const { t, i18n } = useTranslation();

    const filteredToken = asset.filter((element) => {

        if (filterAsset) {
            return element.code === filterAsset.code;
        }

        else {
            return asset[0]
        }

    })

    return (

        <IonItem 
            lines='none' 
            hidden={operation.hidden} 
            className='operationsItem' onClick={() => { onClick() }}>

            <IonText slot='start'>
                <IconContext.Provider value={{ size: "28px" }}>

                    <RiExchangeFundsLine />

                </IconContext.Provider>
            </IonText>

            {/* <IonIcon  slot="start"  icon={syncOutline} color="medium"/> */}


            <IonLabel>
                <IonText className="ion-text-wrap">
                    <h5>
                        {
                            ` ${t('operations.pathpayment.STRICT-SEND.TRADE-LABEL-PART')} ${operation.sourceToken?.code} to ${operation.token.code}`
                        }

                    </h5>
                </IonText>
                <IonNote className="operationsItem_IonNote">
                    {moment.unix(operation.timestamp).format("D MMM YYYY")}
                </IonNote>
            </IonLabel>

            <IonLabel slot='end' className='operationsItem_Amount'>


                <IonText color={operation.sourceToken?.code === filteredToken[0].display_code ? 'danger' : "primary"} className="ion-text-wrap">

                    <h5>
                        <NumberFormat value={operation.sourceToken?.code === filteredToken[0].display_code ? operation.sourceAmount?.toString() : operation.amount.toString()}
                            prefix={operation.sourceToken?.code === filteredToken[0].display_code ? "- " : " +"}
                            displayType={'text'}
                            thousandSeparator={true}
                            decimalSeparator="."
                            decimalScale={filteredToken[0].decimal_places}
                            fixedDecimalScale={true}
                            suffix={` ${filteredToken[0].display_code}`}
                        />

                    </h5>

                </IonText>

            </IonLabel>

        </IonItem>
    );
};

export default TradingListItem;